<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import { clientAdmin } from "@/utils/auth";

export default {
  inject: ['setLoading'],
  components: { Vue3ChartJs },
  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Inventory",
      clientAdmin: clientAdmin(),
      text1: "Delivery Challan Report",
      app_currency: '',
      filter: {
        from_date: '',
        to_date: '',
        warehouse_id: '',
        status: '',
        recipient_type: '',
      },
      summary: {},
      data: [],
      warehouses: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
      approvalDetail: {
        show: false,
        data: null,
      },
      docsDetail: {
        show: false,
        documents: [],
        challan_number: '',
      },
    };
  },

  computed: {
    serialNo() {
      return (this.pagination.current_page - 1) * this.pagination.per_page;
    },

    statusBarChart() {
      if (!this.summary || !this.summary.status_counts) return null;
      const sc = this.summary.status_counts;
      const labels = [];
      const values = [];
      const statusMap = {
        draft: 'Draft',
        dispatched: 'Dispatched',
        returned: 'Returned',
        cancelled: 'Cancelled',
        partial_pending: 'Partial Pending',
        partial_dispatched: 'Partial Dispatched'
      };
      for (const key in sc) {
          labels.push(statusMap[key] || key);
          values.push(sc[key]);
      }
      if (!labels.length) return null;
      const colors = ['#4f46e5', '#06b6d4', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6'];
      return {
        type: 'bar',
        data: {
          labels,
          datasets: [{
            label: 'Challans',
            data: values,
            backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            borderRadius: 6,
            barThickness: 40,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            y: { beginAtZero: true, grid: { color: '#f3f4f6' }, ticks: { stepSize: 1 } },
            x: { grid: { display: false } }
          }
        }
      };
    },

    recipientTypeDoughnutChart() {
      if (!this.summary || !this.summary.recipient_type_counts) return null;
      const rc = this.summary.recipient_type_counts;
      const typeMap = {
        'App\\Models\\Customer': 'Customer',
        'App\\Models\\Engineer': 'Engineer',
        'App\\Models\\WorkOrder': 'Work Order',
        'App\\Models\\SalesExecutive': 'Sales Executive',
        'App\\Models\\InternalConsumption': 'Internal Consumption',
      };
      const labels = [];
      const values = [];
      for (const key in rc) {
        if (rc[key] > 0) {
          labels.push(typeMap[key] || key);
          values.push(rc[key]);
        }
      }
      if (!labels.length) return null;
      const colors = ['#4f46e5', '#06b6d4', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6'];
      return {
        type: 'doughnut',
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            borderWidth: 2,
            hoverOffset: 6,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom', labels: { padding: 15, usePointStyle: true, pointStyle: 'circle' } }
          },
          cutout: '65%',
        }
      };
    },

    warehouseDoughnutChart() {
      const map = {};
      (this.data || []).forEach(row => {
        const name = row.warehouse?.name || 'Unknown';
        const amt = parseFloat(row.total || 0);
        map[name] = (map[name] || 0) + amt;
      });
      const labels = Object.keys(map);
      const values = Object.values(map);
      if (!labels.length) return null;
      const colors = ['#10b981', '#f59e0b', '#4f46e5', '#ef4444', '#06b6d4', '#8b5cf6'];
      return {
        type: 'doughnut',
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            borderWidth: 2,
            hoverOffset: 6,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom', labels: { padding: 15, usePointStyle: true, pointStyle: 'circle' } }
          },
          cutout: '65%',
        }
      };
    },
  },

  async mounted() {
    this.app_currency = await this.$appCurrency();
    this.getDropdowns();

    const start = moment().subtract(29, "days");
    const end = moment();

    this.filter.from_date = start.format("YYYY-MM-DD");
    this.filter.to_date = end.format("YYYY-MM-DD");

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        autoUpdateInput: false,
        locale: { format: "DD/MM/YYYY", separator: " - ", cancelLabel: "Clear" },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.filter.from_date = start.format("YYYY-MM-DD");
        this.filter.to_date = end.format("YYYY-MM-DD");
        this.$refs.dateRangeInput.value = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
        this.filterReport();
      }
    );

    this.filterReport();
  },

  methods: {

openDocsDetail(row) {
  this.docsDetail = {
    show: true,
    documents: row.documents || [],
    challan_number: row.challan_number || '',
  };
},

closeDocsDetail() {
  this.docsDetail = {
    show: false,
    documents: [],
    challan_number: '',
  };
},


openApprovalDetail(item) {
  if (!item.stock_approval) return;
  this.approvalDetail = {
    show: true,
    data: item,
  };
},

closeApprovalDetail() {
  this.approvalDetail = {
    show: false,
    data: null,
  };
},

getDocumentUrl(filename) {
  if (!filename) return '';
  return this.$clientImage(filename, 'inventory', this.clientAdmin);
},

viewChallan(id) {
  const route = this.$router.resolve({ name: 'view-delivery-challan', params: { id } });
  window.open(route.href, '_blank');
},

async exportCSV() {
      this.setLoading(true);
      try {
        const payload = { export: 'csv' };
        if (this.filter.from_date) payload.date_from = this.filter.from_date;
        if (this.filter.to_date) payload.date_to = this.filter.to_date;
        if (this.filter.warehouse_id) payload.warehouse_id = this.filter.warehouse_id;
        if (this.filter.status) payload.status = this.filter.status;
        if (this.filter.recipient_type) payload.recipient_type = this.filter.recipient_type;

        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`/reports/delivery-challans?${query_string}`, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `delivery-challan-report-${this.filter.from_date}-to-${this.filter.to_date}.csv`;
        link.click();
        URL.revokeObjectURL(url);
      } catch (error) {
        this.$swalToast('Failed to export CSV', 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async filterReport(page = 1) {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          page,
          date_from: this.filter.from_date,
          date_to: this.filter.to_date,
        };
        if (this.filter.warehouse_id) payload.warehouse_id = this.filter.warehouse_id;
        if (this.filter.status) payload.status = this.filter.status;
        if (this.filter.recipient_type) payload.recipient_type = this.filter.recipient_type;

        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`/reports/delivery-challans?${query_string}`);
        this.summary = response.data.data.summary || {};
        this.data = response.data.data.rows.data;
        this.pagination = {
          current_page: response.data.data.rows.current_page,
          per_page: response.data.data.rows.per_page,
          last_page: response.data.data.rows.last_page,
          total: response.data.data.rows.total,
          links: response.data.data.rows.links
        };
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async getDropdowns() {
      try {
        const [warehouseRes] = await Promise.all([
          axios.get('/inventory/warehouses/dropdown'),
        ]);
        this.warehouses = warehouseRes.data.data;
      } catch (error) {
        console.log('Dropdown load error:', error.message);
      }
    },

    changePage(url) {
      if (!url) return;
      const page = new URL(url).searchParams.get("page");
      this.filterReport(page);
    },

    hasActiveFilter() {
      return this.filter.warehouse_id || this.filter.status || this.filter.recipient_type || this.filter.from_date || this.filter.to_date;
    },

    clearFilter() {
      this.filter.warehouse_id = '';
      this.filter.status = '';
      this.filter.recipient_type = '';
      this.filter.from_date = '';
      this.filter.to_date = '';
      this.$refs.dateRangeInput.value = '';
      this.filterReport();
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatCurrency(val) {
      return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

    formatQty(val) {
      const num = parseFloat(val || 0);
      return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
    },

    getTotalQty(row) {
      return (row.challan_items || []).reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);
    },

    formatStatus(status) {
      if (!status) return '-';
      const map = {
        draft: 'Draft',
        dispatched: 'Dispatched',
        returned: 'Returned',
        cancelled: 'Cancelled',
        partial_pending: 'Partial Pending',
        partial_dispatched: 'Partial Dispatched'
      };
      return map[status] || status;
    },

    statusBadgeClass(status) {
      const map = {
        draft: 'bg-light text-dark',
        dispatched: 'bg-success text-white',
        returned: 'bg-warning text-dark',
        cancelled: 'bg-danger text-white',
        partial_pending: 'bg-info text-white',
        partial_dispatched: 'bg-primary text-white'
      };
      return map[status] || 'bg-secondary text-white';
    },

    formatRecipientType(type) {
      if (!type) return '-';
      const map = {
        'App\\Models\\Customer': 'Customer',
        'App\\Models\\Engineer': 'Engineer',
        'App\\Models\\WorkOrder': 'Work Order',
        'App\\Models\\SalesExecutive': 'Sales Executive',
        'App\\Models\\InternalConsumption': 'Internal Consumption',
      };
      return map[type] || type;
    },

    recipientTypeBadgeClass(type) {
      const map = {
        'App\\Models\\Customer': 'bg-light text-primary border',
        'App\\Models\\Engineer': 'bg-light text-warning border',
        'App\\Models\\WorkOrder': 'bg-light text-success border',
        'App\\Models\\SalesExecutive': 'bg-light text-info border',
        'App\\Models\\InternalConsumption': 'bg-light text-dark border',
      };
      return map[type] || 'bg-light text-dark border';
    },

    changePctClass(val) {
      const num = parseFloat(val || 0);
      if (num > 0) return 'text-success';
      if (num < 0) return 'text-danger';
      return 'text-muted';
    },

    changePctIcon(val) {
      const num = parseFloat(val || 0);
      if (num > 0) return 'ti ti-trending-up';
      if (num < 0) return 'ti ti-trending-down';
      return 'ti ti-minus';
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <button class="btn btn-outline-primary d-flex align-items-center" @click="exportCSV" :disabled="!data || !data.length">
            <i class="ti ti-file-type-csv me-2"></i>Export CSV
          </button>
        </div>
      </div>

      <!-- Summary Cards -->
      <div class="row g-3 mb-3" v-if="summary && summary.total_challans">
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Challans</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ summary.total_challans }}</span>
              <span v-if="summary.challan_change_pct != null" :class="changePctClass(summary.challan_change_pct)" style="font-size:11px;">
                <i :class="changePctIcon(summary.challan_change_pct)" style="font-size:12px;"></i> {{ Math.abs(summary.challan_change_pct) }}%
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Value</span>
              <span class="fw-bold text-success" style="font-size:20px;">{{ formatCurrency(summary.total_value) }}</span>
              <span v-if="summary.value_change_pct != null" :class="changePctClass(summary.value_change_pct)" style="font-size:11px;">
                <i :class="changePctIcon(summary.value_change_pct)" style="font-size:12px;"></i> {{ Math.abs(summary.value_change_pct) }}%
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Tax</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ formatCurrency(summary.total_tax) }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Qty</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ formatQty(summary.total_qty) }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Unique Recipients</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ summary.unique_recipients }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Avg Challan Value</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ formatCurrency(summary.avg_challan_value) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts -->
      <div class="row g-3 mb-3" v-if="data && data.length">
        <div class="col-md-6">
          <div class="card mb-0 border-0 shadow-sm" v-if="statusBarChart">
            <div class="card-header border-0 pb-0">
              <h6 class="fw-bold mb-0"><i class="ti ti-chart-bar me-1 text-primary"></i>Challans by Status</h6>
            </div>
            <div class="card-body" style="height:280px;">
              <vue3-chart-js v-bind="statusBarChart" :key="'bar-'+data.length" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mb-0 border-0 shadow-sm" v-if="recipientTypeDoughnutChart">
            <div class="card-header border-0 pb-0">
              <h6 class="fw-bold mb-0"><i class="ti ti-users me-1 text-primary"></i>By Recipient Type</h6>
            </div>
            <div class="card-body" style="height:280px;">
              <vue3-chart-js v-bind="recipientTypeDoughnutChart" :key="'rt-'+data.length" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mb-0 border-0 shadow-sm" v-if="warehouseDoughnutChart">
            <div class="card-header border-0 pb-0">
              <h6 class="fw-bold mb-0"><i class="ti ti-building-warehouse me-1 text-primary"></i>By Warehouse</h6>
            </div>
            <div class="card-body" style="height:280px;">
              <vue3-chart-js v-bind="warehouseDoughnutChart" :key="'wh-'+data.length" />
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card border-0">
        <div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
          <div class="d-flex align-items-center flex-wrap mb-1">
            <div class="me-3" v-if="hasActiveFilter()">
              <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
            </div>
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>
            <div class="me-3">
              <vue-select
                v-model="filter.warehouse_id"
                :options="warehouses"
                label="name"
                :reduce="w => w.id"
                placeholder="Warehouse"
                :clearable="true"
                @update:modelValue="filterReport()"
                style="min-width: 180px;"
              ></vue-select>
            </div>
            <div class="me-3">
              <vue-select
                v-model="filter.status"
                :options="[
                  { label: 'Draft', value: 'draft' },
                  { label: 'Dispatched', value: 'dispatched' },
                  { label: 'Returned', value: 'returned' },
                  { label: 'Cancelled', value: 'cancelled' },
                  { label: 'Partial Pending', value: 'partial_pending' },
                  { label: 'Partial Dispatched', value: 'partial_dispatched' },
                ]"
                label="label"
                :reduce="s => s.value"
                placeholder="Status"
                :clearable="true"
                @update:modelValue="filterReport()"
                style="min-width: 180px;"
              ></vue-select>
            </div>
            <div class="me-3">
              <vue-select
                v-model="filter.recipient_type"
                :options="[
                  { label: 'Customer', value: 'App\\Models\\Customer' },
                  { label: 'Engineer', value: 'App\\Models\\Engineer' },
                  { label: 'Work Order', value: 'App\\Models\\WorkOrder' },
                  { label: 'Sales Executive', value: 'App\\Models\\SalesExecutive' },
                  { label: 'Internal Consumption', value: 'App\\Models\\InternalConsumption' },
                ]"
                label="label"
                :reduce="r => r.value"
                placeholder="Recipient Type"
                :clearable="true"
                @update:modelValue="filterReport()"
                style="min-width: 180px;"
              ></vue-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body card-table-wrapper">
            <div class="custom-datatable-filter table-responsive">
              <table class="card-table" v-if="data && data.length">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Challan No.</th>
                    <th>Recipient</th>
                    <th>Warehouse</th>
                    <th>Status</th>
                    <th>Dispatch Date</th>
                    <th>Qty</th>
                    <th>Subtotal</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th>Document</th>
                    <th>Approval</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data" :key="row.id">
                    <td>{{ serialNo + index + 1 }}.</td>
                    <td>{{ formatDate(row.created_at) }}</td>
                    <td>
                    <a href="javascript:void(0);" class="text-primary fw-bold" @click="viewChallan(row.id)">{{ row.challan_number }}</a>
                    </td>
                    <td>
                      <span>{{ row.recipient_details?.name || '-' }}</span>
                      <br>
                      <span class="badge rounded-pill" :class="recipientTypeBadgeClass(row.recipient_type)" style="font-size:10px;">{{ formatRecipientType(row.recipient_type) }}</span>
                    </td>
                    <td>
                      <span class="badge bg-light text-primary border rounded-pill">{{ row.warehouse?.name || '-' }}</span>
                    </td>
                    <td>
                      <span class="badge rounded-pill" :class="statusBadgeClass(row.status)">{{ formatStatus(row.status) }}</span>
                    </td>
                    <td>{{ formatDate(row.dispatch_date) }}</td>
                    <td>{{ getTotalQty(row) }}</td>
                    <td>{{ formatCurrency(row.subtotal) }}</td>
                    <td>{{ formatCurrency(row.tax_amount) }}</td>
                    <td><strong>{{ formatCurrency(row.total) }}</strong></td>
                    <td>
                      <template v-if="row.documents && row.documents.length === 1">
                        <a :href="row.documents[0].document_url" target="_blank"
                          style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border:1px solid #e5e7eb;border-radius:6px;font-size:11px;color:#4f46e5;text-decoration:none;background:#f9fafb;max-width:130px;"
                          :title="row.documents[0].name">
                          <i :class="row.documents[0].type && row.documents[0].type.includes('pdf') ? 'ti ti-file-type-pdf' : 'ti ti-photo'"
                            style="font-size:13px;flex-shrink:0;"
                            :style="row.documents[0].type && row.documents[0].type.includes('pdf') ? 'color:#e84040;' : 'color:#6366f1;'"></i>
                          <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ row.documents[0].name }}</span>
                        </a>
                      </template>
                      <template v-else-if="row.documents && row.documents.length > 1">
                        <button class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                          style="font-size:11px;padding:3px 8px;border-radius:6px;"
                          @click="openDocsDetail(row)">
                          <i class="ti ti-paperclip" style="font-size:13px;"></i> {{ row.documents.length }} files
                        </button>
                      </template>
                      <span v-else class="text-muted" style="font-size:12px;">-</span>
                    </td>
                    <td>
                      <button v-if="row.challan_items && row.challan_items.some(i => i.stock_approval)"
                        class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                        style="font-size:11px;padding:3px 8px;border-radius:6px;"
                        @click="openApprovalDetail(row.challan_items.find(i => i.stock_approval))">
                        <i class="ti ti-info-circle" style="font-size:13px;"></i> Details
                      </button>
                      <span v-else class="text-muted" style="font-size:12px;">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="p-3 text-center text-muted">No records found.</div>

              <!-- Pagination -->
              <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
                <ul class="pagination pagination-sm">
                  <li v-for="(link, index) in pagination.links" :key="index"
                    :class="['page-item', { active: link.active, disabled: !link.url }]">
                    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <!-- ============ Documents Detail Modal ============ -->
<div class="modal fade" :class="{ show: docsDetail.show }"
  :style="docsDetail.show ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

      <div class="modal-header" style="padding:14px 18px;border-bottom:1px solid #f0f1f5;background:#f8f9fb;">
        <div style="display:flex;align-items:center;gap:8px;">
          <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#eef2ff;border-radius:8px;">
            <i class="ti ti-files" style="font-size:15px;color:#4f46e5;"></i>
          </span>
          <div>
            <h6 class="fw-bold mb-0" style="font-size:14px;">Documents</h6>
            <span class="text-muted" style="font-size:12px;">{{ docsDetail.challan_number }}</span>
          </div>
        </div>
        <button type="button" class="btn-close" @click="closeDocsDetail"></button>
      </div>

      <div class="modal-body" style="padding:16px 18px;">
        <div v-for="doc in docsDetail.documents" :key="doc.id"
          style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;margin-bottom:8px;">
          <div style="display:flex;align-items:center;gap:8px;overflow:hidden;">
            <i :class="doc.type && doc.type.includes('pdf') ? 'ti ti-file-type-pdf' : 'ti ti-photo'"
              style="font-size:20px;flex-shrink:0;"
              :style="doc.type && doc.type.includes('pdf') ? 'color:#e84040;' : 'color:#6366f1;'"></i>
            <div style="overflow:hidden;">
              <span style="font-size:13px;font-weight:500;color:#374151;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ doc.name }}</span>
              <span style="font-size:10px;color:#9ca3af;">{{ doc.type || 'file' }}</span>
            </div>
          </div>
          <a :href="doc.document_url" target="_blank"
            style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;background:#eef2ff;border-radius:6px;color:#4f46e5;text-decoration:none;flex-shrink:0;">
            <i class="ti ti-external-link" style="font-size:14px;"></i>
          </a>
        </div>
      </div>

      <div class="modal-footer" style="padding:10px 18px;border-top:1px solid #f0f1f5;">
        <button type="button" class="btn btn-sm btn-light" @click="closeDocsDetail">Close</button>
      </div>

    </div>
  </div>
</div>
<div v-if="docsDetail.show" class="modal-backdrop fade show" style="z-index:1055;" @click="closeDocsDetail"></div>

  <!-- ============ Approval Detail Modal ============ -->
<div class="modal fade" :class="{ show: approvalDetail.show }"
  :style="approvalDetail.show ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;" v-if="approvalDetail.data && approvalDetail.data.stock_approval">

      <!-- Header -->
      <div class="modal-header" style="padding:14px 18px;border-bottom:1px solid #f0f1f5;"
        :style="approvalDetail.data.stock_approval.status === 'approved' ? 'background:#f0fdf4;' : 'background:#fef2f2;'">
        <div style="display:flex;align-items:center;gap:8px;">
          <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;"
            :style="approvalDetail.data.stock_approval.status === 'approved' ? 'background:#dcfce7;' : 'background:#fee2e2;'">
            <i :class="approvalDetail.data.stock_approval.status === 'approved' ? 'ti ti-check' : 'ti ti-x'"
              :style="approvalDetail.data.stock_approval.status === 'approved' ? 'font-size:15px;color:#22c55e;' : 'font-size:15px;color:#e84040;'"></i>
          </span>
          <div>
            <h6 class="fw-bold mb-0" style="font-size:14px;">Approval Details</h6>
            <span class="badge rounded-pill mt-1" style="font-size:10px;"
              :class="approvalDetail.data.stock_approval.status === 'approved' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
              {{ approvalDetail.data.stock_approval.status }}
            </span>
          </div>
        </div>
        <button type="button" class="btn-close" @click="closeApprovalDetail"></button>
      </div>

      <!-- Body -->
      <div class="modal-body" style="padding:16px 18px;">

        <!-- Remark -->
        <div class="mb-3">
          <label style="font-size:11px;color:#9e9e9e;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Remark</label>
          <p style="font-size:13px;color:#1a1d23;margin:4px 0 0;line-height:1.5;">
            {{ approvalDetail.data.stock_approval.remark || '-' }}
          </p>
        </div>

        <!-- Document -->
        <div class="mb-3">
          <label style="font-size:11px;color:#9e9e9e;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Document</label>
          <div v-if="approvalDetail.data.stock_approval.document" style="margin-top:6px;">
            <img :src="getDocumentUrl(approvalDetail.data.stock_approval.document)"
              style="max-width:100%;max-height:200px;border-radius:8px;border:1px solid #e5e7eb;object-fit:contain;cursor:pointer;"
              @click="window.open(getDocumentUrl(approvalDetail.data.stock_approval.document), '_blank')"
              @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
            <a :href="getDocumentUrl(approvalDetail.data.stock_approval.document)" target="_blank"
              style="display:none;align-items:center;gap:6px;padding:6px 12px;border:1px solid #e5e7eb;border-radius:8px;font-size:12px;color:#4f46e5;text-decoration:none;background:#f9fafb;">
              <i class="ti ti-file-filled" style="font-size:16px;"></i>
              {{ approvalDetail.data.stock_approval.document }}
              <i class="ti ti-external-link" style="font-size:12px;"></i>
            </a>
          </div>
          <p v-else style="font-size:13px;color:#9e9e9e;margin:4px 0 0;">-</p>
        </div>

        <!-- Actioned By -->
        <div class="mb-1">
          <label style="font-size:11px;color:#9e9e9e;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Actioned By</label>
          <div style="display:flex;align-items:center;gap:8px;margin-top:6px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;background:#eef2ff;border-radius:50%;font-size:12px;font-weight:600;color:#4f46e5;">
              {{ approvalDetail.data.stock_approval.actioned_by?.name?.charAt(0) || '?' }}
            </span>
            <div>
              <span style="font-size:13px;font-weight:500;color:#1a1d23;">{{ approvalDetail.data.stock_approval.actioned_by?.name || '-' }}</span>
              <span style="font-size:11px;color:#9e9e9e;display:block;">{{ formatDate(approvalDetail.data.stock_approval.created_at) }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer" style="padding:10px 18px;border-top:1px solid #f0f1f5;">
        <button type="button" class="btn btn-sm btn-light" @click="closeApprovalDetail">Close</button>
      </div>

    </div>
  </div>
</div>
<div v-if="approvalDetail.show" class="modal-backdrop fade show" style="z-index:1055;" @click="closeApprovalDetail"></div>
</template>

<style scoped>
    .table-responsive {
        overflow-y: auto;
    }
</style>